<
<template>
	<App title="Inventories">
		<div class="row">
			<div class="col">
				<Block>
					<template #header>
						<h3 class="block-title">Inventory Items</h3>
					</template>
					<Datatable :options="options" />
				</Block>
			</div>
		</div>
	</App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Config } from 'datatables.net-bs5'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		Datatable,
	},
})
class Group extends Vue {
	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []
		
		columns.push({
			data: 'reference',
			title: 'Reference no',
		})
		columns.push({
			data: 'warehouse_name',
			title: 'From',
		})
		columns.push({
			data: 'station_name',
			title: 'To',
		})
		columns.push({
			data: 'quantity',
			title: 'No. of Items',
		})
	
		columns.push({
			name: 'Date Created',
			data: 'reference_created_at',
			title: 'Date Created',
			render: CellRender.date(),
			orderable: true,
		})
		columns.push(Column.actions(this.$gate))
		return columns
	}

	get options(): Config {
		return {
			ajax: {
				url: this.route('assignment.ajax.table'),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
			order: [[3, 'desc']],
		}
	}
}

export default toNative(Group)
</script>
>
